export default __webpack_public_path__ + "fonts/proximanova-regular.woff2";